import React, {useEffect} from 'react';
import JobStatisticTable from "../components/JobStatisticTable";
import JobStatisticChart from "../components/JobStatisticChart";
import RangeDatePicker from "../../../../../components/DatePicker/RangeDatePicker";
import {useForm} from "react-hook-form";
import {InputFilter} from "../../../staffReport/models";
import {useAppDispatch} from "../../../../../helpers/redux";
import {getJobStatistic} from "../../jobReport.reducer";
import Button from "../../../../../components/Button/Button";
const JobStatisticPage = () => {
    const {
        control,
        handleSubmit,
        watch,
        reset,
    } = useForm<InputFilter>({defaultValues: {startDate: new Date().toISOString(), endDate: new Date().toISOString()}});
    const dispatch = useAppDispatch();

    const startDate = watch('startDate');
    const endDate = watch('endDate');

    useEffect(() => {
        dispatch(
            getJobStatistic({
                startDate: new Date().toISOString(),
                endDate: new Date().toISOString(),
            })
        );
    }, []);

    const onSubmit = (data: InputFilter) => {
        let localStart = new Date(data.startDate).toISOString();
        let localEnd = new Date(data.endDate).toISOString();
        dispatch(
            getJobStatistic({
                startDate: localStart,
                endDate: localEnd,
            })
        );
    }

    const onResetClicked = () => {
        reset();
        dispatch(
            getJobStatistic({
                startDate: new Date().toISOString(),
                endDate: new Date().toISOString(),
            })
        );
    }

    return (
        <div>
            <div className="p-2 md:p-10 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
                <div className="flex justify-items-center">
                    <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">Job Statistic</h1>
                </div>
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <RangeDatePicker startName='startDate' endName='endDate' startValue={new Date(startDate)} endValue={new Date(endDate)} control={control}/>
                        <div className="flex items-center justify-end">
                            <div className={"mx-2"}>
                                <Button
                                    color="success"
                                    type="button"
                                    title="Reset"
                                    onClick={onResetClicked}
                                />
                            </div>
                            <Button
                                color="success"
                                type="submit"
                                title="Filter"
                            />
                        </div>
                    </form>
                </div>
                <div className="mt-3">
                    <JobStatisticChart />
                    <JobStatisticTable startDate={startDate} endDate={endDate} />
                </div>
            </div>
        </div>
    );
};

export default JobStatisticPage;
